<template>
  <section class="section">

    <b-breadcrumb :items="[
        { text: this.customerName, to: '/' },
        { text: 'Utenti', to: '/users' },
        { text: form.username, href: '#', active: true }
        ]">
    </b-breadcrumb>

    <div class="row">
      <div class="col">

        <div class="card">
          <div class="card-block">

            <div class="row justify-content-md-center">
              <form role="form" ref="form" class="needs-validation col col-xs-12 col-lg-10 centered-col" novalidate @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label class="control-label">Livello</label>
                  <select v-model="form.level" class="form-control">
                    <option value="3">Utente</option>
                    <option value="2">Amministratore</option>
                    <option value="1" v-if="this.user.superAdmin">Super Amministratore</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="control-label">Username</label>
                  <input required type="text" class="form-control" v-model.trim="form.username">
                </div>
                <div class="form-group">
                  <label class="control-label">Referente</label>
                  <input required type="text" class="form-control" v-model.trim="form.name">
                </div>
                <div class="form-group">
                  <b-form-group label="Siti">
                    <b-form-checkbox-group name="sites" v-model="selectedSites"
                      :options="sites.map(s => { return { text: s.name, value: s.id } })">
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
                <div class="form-group">
                  <label class="control-label">Password</label>
                  <input type="password" class="form-control" v-model.trim="form.password">
                </div>
                <div class="form-group">
                  <label class="control-label">Stato</label>
                  <div class="row">
                    <div class="col">
                      <label>
                          <input name="inchannel-radios" type="radio" :value="1" v-model="form.active">
                          <span>Attivo</span>
                      </label>
                      <label>
                          <input name="inchannel-radios" type="radio" :value="0" v-model="form.active">
                          <span>Non attivo</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group has-warning">
                  <label class="control-label">E-mail</label>
                  <input required type="email" class="form-control" v-model.trim="form.email">
                  <span v-if="isNew" class="has-warning">La password verrà inviata all'indirizzo e-mail specificato</span>
                </div>
                <div class="form-group has-warning">
                  <label class="control-label">Nome cliente</label>
                  <input type="text" class="form-control" v-model.trim="form.altCustomerName">
                </div>
                <div class="form-group" v-if="isSuperAdmin">
                  <div class="mb-2">
                    <span>Permessi</span>
                  </div>
                  <div>
                    <b-form-checkbox v-model="permMeasures" :value="true" :unchecked-value="false">
                      Misure
                    </b-form-checkbox>
                  </div>
                  <div>
                    <b-form-checkbox v-model="permDe" :value="true" :unchecked-value="false">
                      Diagnosi Energetica
                    </b-form-checkbox>
                  </div>
                  <div>
                    <b-form-checkbox v-model="permIndicators" :value="true" :unchecked-value="false">
                      Indicatori
                    </b-form-checkbox>
                  </div>
                  <div>
                      <b-form-checkbox v-model="permBillAudit" :value="true" :unchecked-value="false">
                        Bill Audit
                      </b-form-checkbox>
                    </div>
                  <div>
                    <b-form-checkbox v-model="permReports" :value="true" :unchecked-value="false">
                      Reports
                    </b-form-checkbox>
                  </div>
                </div>

                <div class="row">
                    <div class="col right">
                      <a v-on:click="cancelEditing()" class="btn btn-secondary">Annulla</a>
                      <b-btn variant="danger" v-b-modal.modalDelete>Elimina</b-btn>
                      <button type="submit" class="btn btn-success">Salva</button>
                    </div>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

      <b-modal id="modalDelete"
          ref="modal"
          centered
          title="Conferma cancellazione"
          header-bg-variant="danger"
          ok-title="Procedi"
          ok-variant="danger"
          @ok="goDelete">

          <p>Procedere con la cancellazione dell'utente <b>{{ this.form.nickname }}</b>?</p>
    </b-modal>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import customerMenu from "../Menu.vue"

export default {
  name: "CustomerUser",
  created() {
    if(this.reset) {
      this.form = {}
    }
    if(this.$route.params.guid) {
      this.$store.dispatch('users/get', this.$route.params.guid).then( (data) => {
        this.form = data
        this.selectedSites = data.sites.map( s => s.id )
        this.permMeasures = data.permissionMeasures; 
        this.permDe = data.permissionDe;
        this.permIndicators = data.permissionIndicators;
        this.permReports = data.permissionReports;   
        this.permBillAudit = data.permissionBillAudit    
      })
    }
  },
  props: ['reset'],
  components: {
    customerMenu
  },
  data() {
    return {
      form: {},
      selectedSites: [],
      permMeasures: null,
      permDe: null,
      permIndicators: null,
      permReports: null,
      permBillAudit: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    sites() {
      return this.user.sites
    },
    isNew() {
      return !this.$route.params.guid
    },
    customerName() {
      return this.user.customerName
    },
    isSuperAdmin() {
      return this.$store.state.user && this.$store.state.user.level == 1
    },
  },
  methods: {
    cancelEditing() {
      this.$router.push('/users')
    },
    goDelete() {
      this.$store.dispatch('users/delete', this.form.guid).then( () => {
        // this.$toasted.show('Utente eliminato', { duration: 3000, icon : 'check', theme: "bubble" })
        this.$notify({
          type: "success",
          text: "Utente eliminato",
          title: 'Successo'
        }); 
        this.$store.dispatch('customers/refresh')
        this.$router.push('/users')
      })
    },
    handleSubmit() {
      if (! this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add('was-validated');
        this.$notify({
          type: "error",
          text: "Compilare i campi obbligatori",
          title: 'Errore',
        });
        return;
      }
      this.submit();
    },
    submit () {
      this.form.customerGuid = this.$store.state.customers.selected.guid
      this.form.sites = [];
      if(this.selectedSites.length > 0) {
        this.selectedSites.forEach(item => {
          const site = this.sites.find(site => site.id == item);
          this.form.sites.push(site);
        })
      }

      if(!this.permMeasures) {
        this.permMeasures = false;
      }
      if(!this.permDe) {
        this.permDe = false;
      }
      if(!this.permIndicators) {
        this.permIndicators = false;
      }
      if(!this.permReports) {
        this.permReports = false;
      }
      this.form.permissionMeasures = this.permMeasures;
      this.form.permissionDe = this.permDe;
      this.form.permissionIndicators = this.permIndicators;
      this.form.permissionReports = this.permReports;
      this.form.permBillAudit = this.permBillAudit
      this.$store.commit("loading")
      this.$store.dispatch('users/edit', this.form).then( (response) => {
        this.$store.commit("stopLoading")
        if(response.code == -2) {
          this.$notify({
            type: "error",
            text: response.message,
            title: 'Errore',
          });
        } else {
          this.$notify({
            type: "success",
            text: "Dati salvati",
            title: 'Successo'
          });    
          this.$router.push('/users')
        }
      })
    }
  }
}
</script>
<style scoped>
.content ul {
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Users/User.vue